import React, { useEffect, useState } from "react";
import axios from "axios";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

const MenuItem = ({ product }) => (
  <div
    data-testid={`craft-menu-item-${product.id}`}
    className="break-inside-avoid flex items-baseline gap-3 py-2.5 border-b border-[rgba(179,145,74,0.14)]"
  >
    <span className="w-1.5 h-1.5 rounded-full border-[1.5px] border-[#B3914A] shrink-0" />
    <span className="font-body text-[var(--hoa-cream-50)] text-sm sm:text-base leading-snug min-w-0">
      {product.name}
    </span>
  </div>
);

export const TheCraft = () => {
  const [menu, setMenu] = useState([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/menu`)
      .then((res) => setMenu(res.data || []))
      .catch(() => setFailed(true));
  }, []);

  return (
    <section id="craft" data-testid="story-craft-section" className="hoa-texture hoa-grain">
      <div className="relative z-[1] mx-auto w-full max-w-[1120px] px-5 sm:px-6 py-20 sm:py-28">
        <Reveal>
          <div className="flex items-center gap-4 mb-8 sm:mb-10">
            <span className="font-label text-[10px] sm:text-[11px] tracking-[0.3em] uppercase hoa-gold-text">
              04 — The Craft
            </span>
            <span className="flex-1 h-px bg-[rgba(179,145,74,0.35)]" />
          </div>
        </Reveal>

        <div className="max-w-3xl">
          <Reveal>
            <h2 className="font-display text-[var(--hoa-cream-50)] text-4xl sm:text-5xl leading-[1.1]">
              Pure vegetarian, eggless.
              <br />
              <span className="hoa-gold-text">Absolute indulgence.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="font-body text-[rgba(240,233,216,0.75)] text-base sm:text-lg leading-[1.85] mt-7">
              Artisanal baking that proves indulgence needs no compromise — every recipe in the house
              is pure vegetarian and entirely eggless, and not one of them will let you tell the
              difference.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <p className="font-label text-[10px] tracking-[0.3em] uppercase text-[rgba(240,233,216,0.55)] mt-14 mb-2">
            The Forte
          </p>
        </Reveal>

        <div data-testid="craft-menu">
          {failed && menu.length === 0 && (
            <p className="font-body text-[rgba(240,233,216,0.55)] text-sm mt-6" data-testid="craft-menu-error">
              The menu is being written — please check back in a moment.
            </p>
          )}
          {menu.map((cat, ci) => (
            <Reveal key={cat.category} delay={0.04 * ci}>
              <div className="mt-8" data-testid={`craft-menu-category-${slug(cat.category)}`}>
                <div className="flex items-baseline gap-4">
                  <span className="font-display text-[var(--hoa-gold-300)] text-2xl sm:text-3xl leading-tight">
                    {cat.category}
                  </span>
                  <span className="flex-1 h-px bg-[rgba(179,145,74,0.25)] self-center" />
                </div>
                {cat.note && (
                  <p
                    data-testid={`craft-menu-note-${slug(cat.category)}`}
                    className="font-body italic text-[var(--hoa-gold-300)] text-xs sm:text-sm mt-2"
                  >
                    {cat.note}
                  </p>
                )}
                <div className="mt-3 columns-1 sm:columns-2 lg:columns-3 gap-x-10">
                  {cat.products.map((p) => (
                    <MenuItem key={p.id} product={p} />
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 border-t border-[rgba(179,145,74,0.25)] pt-8 max-w-3xl">
            <p className="font-body text-[rgba(240,233,216,0.7)] text-sm sm:text-base leading-[1.8]">
              Baked in a hygiene-first home kitchen — gloved hands, sanitised surfaces, baked-to-order
              freshness — and finished like it is going somewhere special.
            </p>
            <p className="font-display italic hoa-gold-text text-xl sm:text-2xl mt-4">Because you are.</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
